// Ajax (promise)
// --------------------------------------------------

async function ajax(method, url, data = null) {
	return new Promise(function (resolve, reject) {
		var req = new XMLHttpRequest();

		req.open(method, url, true);

		req.onload = () => {
			if (req.status == 200) {
				// Resolve the promise with the response text
				resolve(req.response);
			} else {
				// Reject the promise with the status text
				reject(Error(req.statusText));
			}
		};

		req.onerror = () => {
			reject(Error('Network Error'));
		};

		req.setRequestHeader('Access-Control-Allow-Origin', '*');

		req.send(data);
	});
}
